import { appTarget } from "@/portal/appMode";
import { istHomescreenApp } from "@/portal/listenApi";
import { istInAppBrowser } from "@/portal/installPrompt";

/* Eine einzige Quelle für „App oder Portal?". Entscheidet über die Fensterbreite:
   breit (Computer) → Kundenbereich (/portal), schmal (Handy/Tablet) → Robbie-App (/app).
   Reihenfolge: gespeicherte Vorliebe (Schalter) > installierte App / WhatsApp-Browser > Breite.
   So landen Kunden auch nach Rückläufen (Zahlung, SEPA, WhatsApp) immer in ihrer gewohnten Hülle. */
export const PORTAL_MIN_BREITE = 1024;

export const gespeicherteVorliebe = () => {
  try { const p = localStorage.getItem("robbie_start_ziel"); return p === "app" || p === "portal" ? p : ""; } catch { return ""; }
};

export const istSchmal = () => {
  if (typeof window === "undefined") return false;
  try { return window.matchMedia(`(max-width: ${PORTAL_MIN_BREITE - 1}px)`).matches; }
  catch { return (window.innerWidth || 0) < PORTAL_MIN_BREITE; }
};

/** "app" | "portal" – die gewünschte Hülle für den aktuellen Kunden. */
export const kundenBereich = () => {
  const v = gespeicherteVorliebe();
  if (v) return v;
  if (istHomescreenApp() || istInAppBrowser()) return "app";  // installierte App / WhatsApp-Browser bleibt immer App
  return istSchmal() ? "app" : "portal";
};

/** Startpfad nach dem Login: /app oder /portal. */
export const kundenZiel = () => (kundenBereich() === "app" ? "/app" : "/portal");

/** Portal-Bereich (z. B. "websites", "social") in das passende Ziel übersetzen – App-Pfad oder Portal-Hash. */
export const zielFuer = (section = "uebersicht", portalHash = "") => {
  if (kundenBereich() === "app") { const t = appTarget(section); return `${t.pathname}${t.hash || ""}`; }
  return `/portal${portalHash || (section && section !== "uebersicht" ? `#${section}` : "")}`;
};
